import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { localCurrency } from '@/plugins/currency';
import Loading from '@/components/loading/loading';
import moment from 'moment';
import ModalSubscriptionDiscount from '@/components/subscriptions/modalSubscriptionDiscount/modalSubscriptionDiscount';
import { tagsStringToArray } from '@/plugins/subscriptions_helper';

@Component({
  components: {
    Loading,
    ModalSubscriptionDiscount
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if(vm.getIsToken && !vm.getSubscription) {
        next('/mi-menu/comenzar');
      } else {
        next();
      }
    });
  }
})
export default class SubscriptionHome extends Vue {

  // Actions
  @Action action_getAllSubscriptions;
  @Action action_updateSubscription;
  @Action action_getMenus;
  @Action action_getCurrentOrder;

  // Getters
  @Getter getIsToken;
  @Getter getSubscription;
  @Getter getAllSubscriptions;
  @Getter getCity;
  @Getter getAllMenuItemProducts;
  @Getter getUser;
  @Getter getMenus;
  @Getter getCurrentOrder;

  // Mutations
  @Mutation PATH_TEMPORAL;
  @Mutation SUBSCRIPTION;
  @Mutation SUBSCRIPTION_TEMPORAL;
  @Mutation CURRENT_ORDER;

  isLoading = true;
  validSubscription = false;
  validWeek = false;
  showModalDiscount = false;

  // Errors
  subscriptionErrors = [];
  weekErrors = [];

  get isFirstOpenWeek() {
    let response = false;
    if (
      this.getIsToken &&
      this.getSubscription &&
      this.getSubscription.status === "pending" &&
      this.getSubscription.subsciption_menus &&
      Array.isArray(this.getSubscription.subsciption_menus) &&
      !this.getSubscription.subsciption_menus.length
    ) {
      response = true;
    }
    return response;
  }

  get isValidSubscription() {
    let response = true;
    this.subscriptionErrors = [];
    if (this.getSubscription) {
      if (!this.getSubscription.user_id) {
        response = false;
        this.subscriptionErrors.push("No tienes usuario asignado. Comunícate con soporte");
      }
      if (!this.getSubscription.creation_week_day) {
        response = false;
        this.subscriptionErrors.push("No has asignado un día de entrega");
      }
      if (!this.getSubscription.payment_way || !this.getSubscription.payment_way.length) {
        response = false;
        this.subscriptionErrors.push("No has elegido un método de pago");
      } else {
        if (
          this.getSubscription.payment_way === "credit_card" &&
          !this.getSubscription.credit_card_id
        ) {
          response = false;
          this.subscriptionErrors.push("No has seleccionado una tarjeta de crédito válida");
        }
      }
      if (!this.getSubscription.address_id) {
        response = false;
        this.subscriptionErrors.push("No has elegido una dirección de entrega válida");
      }
      if (
        !this.getSubscription.program_schedule ||
        !this.getSubscription.program_schedule.length
      ) {
        response = false;
        this.subscriptionErrors.push("No has elegido un horario de entrega");
      }
      if (!this.getSubscription.preferences || !this.getSubscription.preferences.length) {
        response = false;
        this.subscriptionErrors.push("No has elegido al menos una preferencia");
      }
      if (!this.getSubscription.details || !this.getSubscription.details.length) {
        response = false;
        this.subscriptionErrors.push("Aún no has seleccionado platos para tu plan");
      }
      if (!this.getSubscription.person_quantity) {
        response = false;
        this.subscriptionErrors.push("No has configurado el número de personas del plan");
      }
    } else {
      response = false;
    }
    return response;
  }

  get isValidWeek() {
    let response = true;
    this.weekErrors = [];
    this.getSubscription.details_subscription_menus.map((menu) => {
      !menu.day.length ? response = false : false; 
    });
    return response;
  }

  get getAddress() {
    let response = null;
    if (
      this.getSubscription.address_id &&
      this.getUser &&
      this.getUser.addresses &&
      this.getUser.addresses.length
    ) {
      response = this.getUser.addresses.find(
        (address) => address.id === this.getSubscription.address_id
      );
    }
    return response;
  }

  get status() {
    let response = "";
    if (
      this.getSubscription &&
      this.getSubscription.status &&
      this.getSubscription.status.length
    ) {
      const status = this.getSubscription.status;
      switch (status) {
        case 'pending':
          response = "Pendiente";
          break;
        case 'active':
          response = "Activa";
          break;
        case 'skip_week':
          response = "Semana pausada";
          break;
        case 'inactive':
          response = "Inactiva"
          break;
      }
    }
    return response;
  }

  get getDeliveryDay() {
    let response = "";
    if(this.getSubscription.deal_date) {
      response = moment(this.getSubscription.deal_date).format("ddd DD-MMM");
    }
    return response;
  }

  get getProgramSchedule() {
    let response = "";
    if(this.getSubscription && this.getSubscription.program_schedule) {
      response = this.getSubscription.program_schedule;
    }
    return response;
  }

  get getRestartDay() {
    let response = "";
    if(this.getSubscription.deal_date) {
      const dealDate = moment(this.getSubscription.deal_date);
      response = dealDate
        .clone()
        .subtract(6, "day")
        .startOf("day")
        .format("ddd DD-MMM");
    }
    return response;
  }

  get getDeadline() {
    let response = "";
    if(this.getSubscription.deadline_update_date) {
      const deadLineDate = moment(this.getSubscription.deadline_update_date);
      response = deadLineDate.format("ddd DD-MMM hh:mm a");
    }
    return response;
  }

  get getAlertMessage() {
    let response = `Configura tu suscripción y los platos de la semana antes del ${
      this.getDeadline
    } para que podamos recibir tu plan y llevarlo hasta la puerta de tu casa`;
    return response;
  }

  get getSubscriptionDiscount() {
    let response = null;
    if(this.getSubscription && this.getSubscription.subscription_discount) {
      response = this.getSubscription.subscription_discount;
    }
    return response;
  }

  get isRestartPossible() {
    let response = true;
    if(this.getSubscription.deal_date) {
      const today = moment(new Date());
      const dealDate = moment(this.getSubscription.deal_date);
      today.set('hour', 0);
      today.set('minute', 0);
      today.set('second', 0);
      if(today.isSameOrAfter(dealDate)) {
        response = false;
      }
    }
    return response;
  }

  get getPreferences() {
    let response = [];
    if(this.getSubscription && this.getSubscription.preferences) {
      response = tagsStringToArray(this.getSubscription.preferences);
    }
    return response;
  }

  get getNotIncluded() {
    let response = [];
    if(this.getSubscription && this.getSubscription.no_include) {
      response = tagsStringToArray(this.getSubscription.no_include);
    }
    return response;
  }

  get isCurrentOrderActive() {
    let response = false;
    if (this.getCurrentOrder && !this.getIsTerminalStatus && !this.getIsFinished) {
      response = true;
    }
    return response;
  }

  get getIsTerminalStatus() {
    let response = false;
    if (this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response =
        status === "troubleshooting_restaurant" ||
        status === "order_not_generated" ||
        status === "order_canceled_by_restaurant" ||
        status === "order_canceled_in_handoff" ||
        status === "troubleshooting_hand_off";
    }
    return response;
  }

  get getIsFinished() {
    let response = false;
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response = status === "order_completed";
    }
    return response;
  }

  get getOrderStatusLabel() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "Orden recibida";
          break;
        case "waiting_for_external_payment":
          response = "Esperando pago externo";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "Alistando";
          break;
        case "delivering_order" : 
          response = "En camino"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "Cancelada"
          break;
        case "order_completed": 
          response = "Entregada"
          break;
      }
    }
    return response;
  }

  get getOrderStatusColor() {
    let response = "";
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      switch (status) {
        case "waiting_restaurant_confirmation":
          response = "#329ACF";
          break;
        case "waiting_for_external_payment":
          response = "#ffdf5f";
          break;
        case "preparing_order":
        case "waiting_pickup_deliveryman":
        case "already_restaurant":
          response = "#9BFB9A";
          break;
        case "delivering_order" : 
          response = "#9BFB9A"
          break;
        case "troubleshooting_restaurant":
        case "order_canceled_by_restaurant":
          response = "#CC0001"
          break;
        case "order_completed": 
          response = "#00F303"
          break;
      }
    }
    return response;
  }

  get isBeforeDeadline() {
    let response = false;
    if(this.getSubscription.deadline_update_date) {
      const today = moment(new Date());
      const deadline = moment(this.getSubscription.deadline_update_date);
      response = today.isBefore(deadline);
    }
    return response;
  }

  async mounted() {
    this.isLoading = true;
    try {
      let reRoute = false;
      if(this.getCity && this.getCity.id) {
        if(this.getIsToken) {
          await this.action_getMenus({ commerceId: this.getCity.id });
          await this.action_getAllSubscriptions({ commerceId: this.getCity.id });
          if(!this.getSubscription) {
            reRoute = true;
          }
        } else {
          reRoute = true;
        }
      }
      reRoute ? this.$router.replace({ name: 'subscriptions_getStarted' }): false;
      this.changeSubscriptionStatus();
      await this.getSubscriptionOrder();
    } catch (error) {
      this.showErrorMessage(error);
    }
    this.isLoading = false;
  }

  @Watch('status')
  async changeSubscriptionStatus() {
    if (this.getSubscription) {
      let status = "";
      if (this.isValidSubscription) {
        
        if (this.getSubscription.status && this.getSubscription.status === "pending") {
          status = "active";
        }
      } else {
        status = "pending";
      }
      this.isLoading = true;
      try {
        if (status.length) {
          const payload = {
            commerceId: this.getCity.id,
            subscriptionId: this.getSubscription.id,
            subscription: {
              subscription: {
                status: status
              }
            }
          };
          await this.action_updateSubscription(payload);
        }
      } catch (error) {
        this.showErrorMessage(error);
      }
      this.isLoading = false;
    }
  }

  async _skipWeek() {
    this.isLoading = true;
    if (this.isBeforeDeadline) {
      try {
        let confirmation = false;
        let payload = {
          commerceId: this.getCity.id,
          subscriptionId: this.getSubscription.id,
          subscription: {
            subscription: {
              status: this.getSubscription.status
            }
          }
        };
        if (this.status === "Activa") {
          payload.subscription.subscription.status = "skip_week";
          let alert = await this.$swal({
            title: "Pausar semana",
            text: "¿Deseas pausar tu plan esta semana?",
            showCancelButton: true,
            confirmButtonText: "Aceptar"
          });
          if (alert && alert.dismiss && alert.dismiss === "cancel") {
            confirmation = false;
          } else if (alert && alert.value && alert.value === true) {
            confirmation = true;
          }
        } else if (this.status === "Semana pausada") {
          payload.subscription.subscription.status = "pending";
          confirmation = true;
        }
        confirmation ? await this.action_updateSubscription(payload) : false;
      } catch (error) {
        this.showErrorMessage(error);
      }
    }
    
    this.isLoading = false;
  }

  async reactivateSubscription() {
    this.isLoading = true;
    if (
      this.getSubscription &&
      this.getSubscription.id &&
      this.getSubscription.status === "inactive" &&
      this.getCity &&
      this.getCity.id
    ) {
      const payload = {
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: {
            status: "pending"
          }
        }
      };
      try {
        await this.action_updateSubscription(payload);
      } catch (error) {
        this.showErrorMessage(error);
      }
    }
    this.isLoading = false;
  }

  async getSubscriptionOrder() {
    try {
      this.isLoading = true;
      if(this.getSubscription && this.getSubscription.last_order) {
        await this.action_getCurrentOrder(this.getSubscription.last_order);
      } else {
        this.CURRENT_ORDER(null);
      }
    } catch (error) {
      this.showErrorMessage(error);
    }
    this.isLoading = false;
  }

  showErrorMessage(error) {
    let msg = "";
    if(error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    }
    this.$swal({
      title: "Error",
      text: "¡Ups! Hubo un error al enviar la solicitud. " + msg
    });
  }

  _onRoute(routeName: string) {
    if (this.isBeforeDeadline && !this.isCurrentOrderActive) {
      const currentRouteName = this.$route.name;
      if (currentRouteName !== routeName) {
        if (routeName === "subscriptions_settings" && !this.isCurrentOrderActive) {
          !this.isValidSubscription ? this._toggleSubscriptionErrorMessage() : false;
        } else if (routeName === "subscriptions_openWeek") {
          !this.isValidWeek ? this._toggleWeekErrorMessage() : false;
        }
        this.$router.push({ name: routeName });
      }
    }
  }

  _onOrderDetail() {
    this.$router.push({
      name: "subscriptions_order",
      params: { order_id: this.getCurrentOrder.id }
    });
  }

  _toggleSubscriptionErrorMessage() {
    this.$swal({
      title: "Advertencia",
      text: this.subscriptionErrors
    });
  }

  _toggleWeekErrorMessage() {
    this.$swal({
      title: "Advertencia",
      text: "Configura los platos de tu semana antes de la fecha límite"
    });
  }

  _toggleDiscount() {
    if(!this.isCurrentOrderActive && this.isBeforeDeadline) {
      this.showModalDiscount = !this.showModalDiscount;
    }
  }

  _money(value) {
    return localCurrency(value);
  }

  getMenuById(menuId) {
    let response = null;
    if(this.getMenus && this.getMenus.length) {
      response = this.getMenus.find((menu) => menu.id === menuId);
    }
    return response;
  }

  tagToString(value: string) {
    return value.replace(/_/g, ' ');
  }
}
